// extracted by mini-css-extract-plugin
export default {"colorBrand":"#254a91","colorWhite":"#fff","colorBlueBright":"#81a9f2","columnContainer":"columnContainer_ymHwq","item":"item_JJfC8","itemLink":"itemLink_uE2K1"};